import { render, staticRenderFns } from "./PlayingArea.vue?vue&type=template&id=17c3f18e&scoped=true&"
import script from "./PlayingArea.vue?vue&type=script&lang=js&"
export * from "./PlayingArea.vue?vue&type=script&lang=js&"
import style0 from "./PlayingArea.vue?vue&type=style&index=0&id=17c3f18e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c3f18e",
  null
  
)

export default component.exports